import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import {
  Navbar,
  Nav,
  Container,
  FormControl,
  DropdownButton,
  Dropdown,
  InputGroup,
} from 'react-bootstrap';
import './index.scss';
import { loginService, register as registerService } from '../../../services/apiService';
import { setJwt, removeJwt } from '../../../utils';
import { useApp } from '../../../contexts/useApp';
import RegoForm from '../../modals/regoForm';
import LoginForm from '../../modals/loginForm';

const Header = () => {
  const loginLocal = data => {
    setJwt(data.jwt);
    action.setProfile({ username: data.user.username, id: data.user.id });
  };
  const history = useHistory();
  const { state, action, set } = useApp();
  const [username, setUsername] = useState('');
  const [isRegoFormModalOpen, setIsRegoFormModalOpen] = useState(false);
  const [isLoginFormModalOpen, setIsLoginFormModalOpen] = useState(false);
  const [isLoginLoading, setIsLoginLoading] = useState(false);
  set('setIsLoginFormModalOpen', setIsLoginFormModalOpen);
  const [isRegoLoading, setIsRegoLoading] = useState(false);

  const login = async () => {
    if (!username) {
      alert('No username');
      return;
    }
    const password = 'password';

    try {
      const data = await loginService(username, password);
      if (data.jwt) {
        loginLocal(data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const logout = () => {
    action.setProfile({ username: '' });
    removeJwt();
  };

  useEffect(() => {
    setUsername(state.profile.username);
  }, [state.profile.username]);

  const register = async formData => {
    setIsRegoLoading(true);
    const reqData = {
      email: formData.email.trim(),
      username: formData.username.trim(),
      password: formData.password.trim(),
    };
    try {
      const { data } = await registerService(reqData);
      loginLocal(data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsRegoLoading(false);
    }
  };

  const formLogin = async ({ username, password }) => {
    try {
      const data = await loginService(username, password);
      if (data.jwt) {
        loginLocal(data);
      }
    } catch (error) {
      console.log(error);
      throw new Error('invalid');
    }
  };

  const createKata = () => {
    if (state.profile.username) {
      window.location.href = '/kata';
      return;
    }

    setIsLoginFormModalOpen(true);
  };

  return (
    <>
      <LoginForm
        isOpen={isLoginFormModalOpen}
        setIsOpen={setIsLoginFormModalOpen}
        submitForm={formLogin}
        setIsRegoFormModalOpen={setIsRegoFormModalOpen}
        isLoginLoading={isLoginLoading}
        setIsLoginLoading={setIsLoginLoading}
      />
      <RegoForm
        isOpen={isRegoFormModalOpen}
        setIsOpen={setIsRegoFormModalOpen}
        submitForm={register}
        isRegoLoading={isRegoLoading}
        setIsRegoLoading={setIsRegoLoading}
      />
      <header className="homeHeader container-fuild">
        <Navbar expand="lg">
          <Container fluid>
            <Navbar.Brand href="http://shuhari.codedoh.com" className="homeHeader_logo">
              Code<span style={{ color: '#F49E63' }}>Doh</span>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="navbarScroll" />
            <Navbar.Collapse id="navbarScroll">
              <Nav className="me-auto my-2 my-lg-0" style={{ maxHeight: '100px' }} navbarScroll>
                <Nav.Link onClick={() => history.push('/')}>TDD Kata</Nav.Link>
                <Nav.Link onClick={createKata}>Create Kata</Nav.Link>
              </Nav>
              {state.profile.username ? (
                <InputGroup className="login-block homeHeader_inputGroup">
                  <FormControl
                    aria-label="greeting username"
                    value={`Hi ${username}`}
                    onChange={e => setUsername(e.target.value)}
                    className="homeHeader_inputGroup_greeting-username"
                  />
                  <DropdownButton variant="outline-secondary" title="" id="input-group-dropdown-2">
                    <Dropdown.Item href="#" onClick={logout}>
                      Logout
                    </Dropdown.Item>
                  </DropdownButton>
                </InputGroup>
              ) : (
                <>
                  <a
                    className="homeHeader_nav-link"
                    role="button"
                    onClick={() => setIsRegoFormModalOpen(true)}
                  >
                    Register
                  </a>
                  <a
                    className="homeHeader_nav-link"
                    role="button"
                    onClick={() => setIsLoginFormModalOpen(true)}
                  >
                    Login
                  </a>
                </>
              )}
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </header>
    </>
  );
};

export default Header;
